// export type InstanceValue<T> = [name: string, value: T];
// export type InstanceValues<T> = [name: string, value: InstanceValue<T> | Array<InstanceValue<T>>[]];

import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { FormInstanceDataTypeEnum } from "../../common/enums/FormInstanceDataTypeEnum";
import { IAttachment } from "../../common/models/IAttachment";

export type FormValueDataType = string | number | boolean | Date;

export interface IFormInstanceValue<T> {
    name: string;
    dataType?: FormInstanceDataTypeEnum;    // optional because in case of grid doesn't make any sense??? unless we add None to enum
    value: T;
}

export interface IFormInstanceHistory {
    //id: number,
    modifiedTimestamp: Date;
    modifiedBy: string;
    values: IFormInstanceValue<FormValueDataType | Array<IFormInstanceValue<FormValueDataType>[]>>[]


//     public DateTimeOffset ModifiedTimestamp { get; set; }

//     public string ModifiedBy { get; set; }

//     public List<FormInstanceValueModel> Values { get; set; }


}

export interface IFormInstanceData {
    id: string | undefined; // document id (provide similar support to alarm EID)
    templateID: number;
    formID: number | undefined;
    objectType: eLynxObjectTypeEnum;
    objectID: number;
    objectName?: string;
    formType: FormTypeEnum;
    formFeatures: FormFeatureEnum;
    openedTimestamp: Date;
    openedBy: string;
    closedTimestamp?: Date;
    closedBy?: string;
    history: IFormInstanceHistory[];
    isDeleted?: boolean;


    attachments: IAttachment[];
}


export enum FormTypeEnum {
    Default = 0
}

export enum FormFeatureEnum  {
    allowClose = 1,
    allowEvents = 2,
    allowAttachments = 4,
    requireSignature = 8
}

// public class FormInstanceDataModel
// {
//     public string ID { get; set; }
//     public int TemplateID { get; set; }
//     public eLynxObjectTypeEnum ObjectType { get; set; }
//     public int ObjectID { get; set; }
//     public FormTypeEnum FormType { get; set; }
//     public DateTimeOffset OpenedTimestamp { get; set; }
//     public string OpenedBy { get; set; }
//     public DateTimeOffset? ClosedTimestamp { get; set; }
//     public string ClosedBy { get; set; }
//     public List<FormInstanceHistoryModel> History { get; set; }
//     public bool IsDeleted { get; set; }
// }

// public class FormInstanceHistoryModel
// {
//     public DateTimeOffset ModifiedTimestamp { get; set; }

//     public string ModifiedBy { get; set; }

//     public List<FormInstanceValueModel> Values { get; set; }
// }

// public class FormInstanceValueModel {
//     public string Name { get; set; }
    
//     public object Value { get; set; }

//     public FormInstanceDataTypeEnum DataType { get; set; }
// }
